import { useFocusBackdrop } from '../meta';

/** Volledige achtergrond die meebeweegt met de geselecteerde titel (Arctic Fuse-stijl). */
export function BackdropLayer() {
  const url = useFocusBackdrop();
  return (
    <div className="focus-backdrop" aria-hidden="true">
      {url && <div key={url} className="focus-backdrop-img" style={{ backgroundImage: `url("${url}")` }} />}
    </div>
  );
}
